<template>
<div ref="ManagerEdit">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑管理员</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="managerlist.length > 1 ? managerlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回系统管理员</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in managerlist" :key="index">
            <div class="TTL-form-submit-box-title">管理员-{{index+1}}</div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">管理员头像</label>
                    <wcupload :option="{size:'large'}" :value="item.thumb" 
                        @finish="(val)=> {
                            item.thumb=val.url;
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">管理员角色<i>*</i></label>
                    <div class="TTL-select">
                    <el-select v-model="item.groupid" placeholder="请选择角色" clearable filterable>
                    <el-option v-for="(group,i) in grouplist" :key="i" :value="group.id" :label="group.name"></el-option>
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">管理员名称<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.name" placeholder="请输入管理员名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">管理员手机号码<i>*</i></label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.phone" placeholder="请输入管理员名称" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">管理员真实姓名</label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.truename" placeholder="请输入管理员真实姓名" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">管理员密码</label>
                    <div class="TTL-input width300 TTL-form-input">
                    <el-input v-model="item.password" placeholder="请输入管理员密码" @change="SaveDataToBrowser" clearable />
                    </div>
                </el-form-item>
                
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_MANAGER from '@/Interface/manager/manager';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            addlimit: 10,        //单次新增限制
            uploadimageIndex:'', //获取当前上传图片的序号
            grouplist:[],        //品种信息
            managerlist:[],      //管理员信息列表
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetManagerGroup();        //获取所有管理员角色
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前已有管理员信息正在编辑，执行此操作会覆盖当前数据，是否执行 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetManagerList(data.ids);
                }).catch(()=> {
                    
                });

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.GetManagerList(data.ids);
            }
        },


        /** 提交数据 **/
        submitData() {
            //调整提交数据
            var data=[];
            for(var i=0;i<this.managerlist.length;i++) data.push(this.managerlist[i]);
            data=JSON.stringify(data);

            var loadingobj=this.$refs.ManagerEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画

            INTERFACE_MODEL_MANAGER.EDIT_MANAGER({managerdata:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
                this.GoBackPets(true);
            });
        },


        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 获取管理员信息详情 **/
        GetManagerList(ids) {
            var loadingobj=this.$refs.ManagerEdit;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_MANAGER.GET_MANAGER_INFOS({ids:ids}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.managerlist=res.data;
            });
        },


        /** 获取管理员角色列表 **/
        GetManagerGroup() {
            INTERFACE_MODEL_MANAGER.GET_GROUP_LIST({}).then((res) => {
                 if(res.status > 0) return false;
                 this.grouplist=res.data;
            });
        },

        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.managerlist);
            localStorage.setItem('addmanagerdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('addmanagerdata');
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetParam() : this.managerlist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'系统管理员',labelentry:'Manager',components:'Manager',isshow:false};
            var data={Method:''};
            if(isdellocal) data.delcomponents='EditManager';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        /** 重置加载数据 **/
        resetParam() {
            this.managerlist=[];
            var managerinfos={groupid:'',name:'',truename:'',thumb:'',phone:'',password:''};
            var data=managerinfos;
            this.managerlist.push(data);
            this.SaveDataToBrowser();
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
</style>